import { Controller } from '@hotwired/stimulus'
import { get } from '@rails/request.js'
import '../charts/index.js'
import { BenchmarkSearchView } from '../charts/fund.js'
// Connects to data-controller="fund"
export default class extends Controller {
  static targets = [
    'fundChart',
    'chartTimestamp',
    'compareChart',
    'chartCompareBox',
    'averageCheckboxes',
    'chartTechnicalModal',
    'chartCompareModal',
    'chartCompareList2',
    'chartCompareList1',
  ]
  static values = {
    fundId: String,
    name: String,
    showBench: Boolean,
    height: Boolean,
    isMobile: Boolean,
    compareData: Array,
    categoryFunds: Array,
    scServer: String
  }

  connect() {
    MST.sc_server = this.scServerValue

    // TODO: Change to event driven
    if (this.hasFundChartTarget) {
      this.loadChart()
    }
    document.addEventListener('loadChart', () => {
      this.loadChart()
    })
    if (this.isMobileValue && this.showBenchValue) {
      window.addEventListener('svgchart:loaded', ({ detail: { status } }) => {
        if (
          status !== MST.SvgChartTechnical.DATA_STATUS_OK &&
          status !== MST.SvgChartTechnical.DATA_STATUS_LOADING
        ) {
          this.chartCompareBoxTarget.classList.add('hidden')
        } else {
          this.chartCompareBoxTarget.classList.remove('hidden')
        }
      })
    }
    this.handleClick = this.handleClick.bind(this);
    document.addEventListener("click", this.handleClick);
  }

  disconnect() {
    document.removeEventListener("click", this.handleClick);
    if (this.chart) {
      // 刪掉圖表
      if (this.hasFundChartTarget) {
        this.fundChartTarget.innerHTML = '';
      } else if (this.hasCompareChartTarget) {
        this.compareChartTarget.innerHTML = '';
      }
      this.chart = null
    }
  }

  loadChart() {
    // wait for the DOM to be ready
    setTimeout(() => {
      MST.SvgChart.setTimeFormatFunction(SW.ChartIntegration.formatTime)
      MST.SvgChart.setNumberFormatFunction(SW.ChartIntegration.formatNumber)
      MST.SvgChart.setTranslateFunction(SW.ChartIntegration.translateString)
      
      if (this.hasFundChartTarget) {
        this.drawBasicInfoChart()
      } else {
        this.drawCompareChart()
      }
    }, 100)
  }

  drawCompareChart() {
    let chart = this.compareChartTarget
    this.chart = new MST.SvgChart(chart)
    let benchmarks = {
      '.N225': { id: '.N225', name: '日経平均', type: 'index', index: 0 },
      '.TOPX': { id: '.TOPX', name: 'TOPIX', type: 'index', index: 1 },
      '.DJI': { id: '.DJI', name: 'ダウ', type: 'index', index: 2 },
      // New code
      '2TCE01': { id: '2TCE01', name: '金', type: 'futures', index: 3 },
      '2TCE12': { id: '2TCE12', name: '原油', type: 'futures', index: 4 },
      'JPY=X': { id: 'JPY=X', name: '米ドル/円', type: 'futures', index: 5 },
    }
    for (let i = 0; i < this.compareDataValue.length; i++) {
      let type = 'fund'

      if (i == 0) { type = 'default' }

      benchmarks[this.compareDataValue[i][0]] = {
        id: this.compareDataValue[i][0],
        name: this.compareDataValue[i][1],
        type: type,
        index: i + 6,
      }
    }

    this.chart.colorSelectList = {}
    this.chart.setLanguage('jp')
    this.chart.setBenchmarks(benchmarks)

    MST.BENCHMARK_LIMIT = this.isMobileValue ? 5 : 10
    MST.RANGE_VIEW_HEIGHT = this.isMobileValue ? 70 : 32
    this.chart.setParams(
      this.compareDataValue[0][0],
      this.compareDataValue[0][1],
      'TYO',
      {
        controller: {
          timeFrame: '1Y',
          showController: true,
          showIndicator: false,
          showBenchmark: true,
          showUpdateBrowser: true,
          showChartRange: true,
          showType: false,
          showReset: false,
          ranges: ['3M', '6M', '1Y', '3Y', '5Y', '10Y', 'ALL'],
        },
        scroll: { showScroll: true },
        technicalList: [['line']],
      },
    )

    for (var i = 1; i < this.compareDataValue.length; i++) {
      this.chart.addBenchmark(this.compareDataValue[i][0], i)
    }
    if (this.hasChartTimestampTarget) {
      this.drawChartTimestamp()
    }
  }

  drawBasicInfoChart() {
    let category_funds = this.categoryFundsValue
    this.chart = new MST.SvgChart(this.fundChartTarget)
    this.chart.setLanguage('jp')
    let defaultBenchmarks = {
      '.N225': { id: '.N225', name: '日経平均', type: 'index', index: 0 },
      '.TOPX': { id: '.TOPX', name: 'TOPIX', type: 'index', index: 1 },
      '.DJI': { id: '.DJI', name: 'ダウ', type: 'index', index: 2 },
      '2TCE01': { id: '2TCE01', name: '金', type: 'futures', index: 3 },
      '2TCE12': { id: '2TCE12', name: '原油', type: 'futures', index: 4 },
      'JPY=X': { id: 'JPY=X', name: '米ドル/円', type: 'futures', index: 5 },
    }

    let index = 6
    for (let i = 0; i < category_funds.length; i++) {
      let fund = category_funds[i]
      if (fund['id'] != this.fundIdValue) {
        defaultBenchmarks[fund['id']] = {
          id: fund['id'],
          name: fund['name'],
          type: 'fund',
          index: index,
        }
        index += 1
      }
    }
    this.chart.setBenchmarks(defaultBenchmarks)
    this.chart.setLanguage('jp')
    this.chart.setBenchmarkTitleFlag(true)
    MST.BENCHMARK_LIMIT = this.isMobileValue ? 5 : 10
    if (this.isMobileValue) {
      if (this.hasChartCompareBoxTarget) {
        this.initChartCompareModal(defaultBenchmarks)
      }
      MST.RANGE_VIEW_HEIGHT = this.showBenchValue ? 125 : 32
    }

    this.chart.setParams(this.fundIdValue, this.nameValue, 'TYO', {
      controller: {
        timeFrame: '1Y',
        showController: true,
        showIndicator: this.isMobileValue ? false : this.showBenchValue,
        showBenchmark: this.isMobileValue ? false : this.showBenchValue,
        showUpdateBrowser: true,
        showChartRange: true,
        showType: false,
        showReset: true,
        ranges: ['3M', '6M', '1Y', '3Y', '5Y', '10Y', 'ALL'],
      },
      scroll: { showScroll: true },
      technicalList: [['mountain', 'fundLine'], ['volume']],
    })
    if (this.hasChartTimestampTarget) {
      this.drawChartTimestamp()
    }
  }

  async drawChartTimestamp() {
    const response = await get('/json/funds/' + this.fundIdValue + '/get_line_daily_json')
    const data = await response.json
    const currentTime =  new Date(data.current_time)
    const formatDate = `${currentTime.getFullYear()}/${(currentTime.getMonth()+1).toString().padStart(2,'0')}/${currentTime.getDate().toString().padStart(2,'0')} ${currentTime.getHours().toString().padStart(2,'0')}:${currentTime.getMinutes().toString().padStart(2,'0')}`
    if (data) {
      this.chartTimestampTarget.innerHTML = `(${formatDate} 更新)`
    }
  }

  filterCheckboxChange() {
    let filterValue = []
    this.averageCheckboxesTarget
      .querySelectorAll('input[type="checkbox"]')
      .forEach((checkbox) => {
        if (checkbox.checked) {
          filterValue.push(checkbox.value)
        }
      })
    this.chart.setBenchmark(filterValue)
  }

  initChartCompareModal(benchmarks) {
    new BenchmarkSearchView(this.fundIdValue)
    Object.values(benchmarks).forEach((benchmark) => {
      let ul = this.chartCompareList2Target
      if (benchmark.type == 'fund') {
        ul = this.chartCompareList1Target
      }
      let c =
        '<li class="flex gap-3.5 items-start py-2.5 border-b border-itf-gray-placeholder">' +
        '<input type="checkbox" class="shrink-0 checkbox_style" id="' +
        benchmark.id +
        '" value="' +
        benchmark.id +
        '" data-action="click->fund#countCompareCheckboxes">' +
        "<label for='" +
        benchmark.id +
        "'>" +
        benchmark.name +
        '</label>' +
        '</li>'
      ul.insertAdjacentHTML('beforeend', c)
    })
  }

  chartTechnicalSubmit() {
    // Unchecked other checkboxes
    this.uncheckFilterCheckboxes()

    let selectedValue = []
    // Get checked value
    this.chartTechnicalModalTarget
      .querySelectorAll('input[type="checkbox"]')
      .forEach((checkbox) => {
        if (checkbox.checked) {
          selectedValue.push(checkbox.value)
        }
      })
    // Set chart tech value to selected value
    this.chart.setTech(selectedValue)

    // Close Modal
    this.chartTechnicalModalTarget.classList.add('hidden')
    document.querySelector('body').classList.remove('overflow-y-hidden')
  }

  hideChartTechnicalModal() {
    this.chartTechnicalModalTarget
      .querySelectorAll('input[type="checkbox"]')
      .forEach((checkbox) => {
        if (checkbox.checked) {
          checkbox.checked = false
        }
      })
    this.chart.setTech([])
    this.chartTechnicalModalTarget.classList.add('hidden')
    document.querySelector('body').classList.remove('overflow-y-hidden')
  }

  showChartTechnicalModal() {
    this.chartTechnicalModalTarget.classList.remove('hidden')
    document.querySelector('body').classList.add('overflow-y-hidden')
  }

  countCompareCheckboxes(e) {
    // Count checkboxes
    let checkedBoxesCount = this.chartCompareModalTarget.querySelectorAll(
      'input[type="checkbox"]:checked',
    )
    if (checkedBoxesCount.length > 5) {
      alert(
        '最大5つまでです\n同時に比較できるのは指数とファンド\n合わせて最大5つまでです。',
      )
      e.target.checked = false
    }
  }

  hideChartCompareModal() {
    // Uncheck inside modal Checkboxes
    this.chartCompareModalTarget
      .querySelectorAll('input[type="checkbox"]')
      .forEach((checkbox) => {
        if (checkbox.checked) {
          checkbox.checked = false
        }
      })

    // Set chart back to init value
    this.chart.setBenchmark([])
    this.chartCompareModalTarget.classList.add('hidden')
    document.querySelector('body').classList.remove('overflow-y-hidden')
  }

  showChartCompareModal() {
    this.chartCompareModalTarget.classList.remove('hidden')
    document.querySelector('body').classList.add('overflow-y-hidden')
  }

  chartCompareSubmit() {
    // Unchecked other checkboxes
    this.uncheckFilterCheckboxes()

    let selectedValue = []
    // Get checked value
    this.chartCompareModalTarget
      .querySelectorAll('input[type="checkbox"]')
      .forEach((checkbox) => {
        if (checkbox.checked) {
          selectedValue.push(checkbox.value)
        }
      })

    // Set chart benckmark value to selected value
    this.chart.setBenchmark(selectedValue)

    // Close Modal
    this.chartCompareModalTarget.classList.add('hidden')
    document.querySelector('body').classList.remove('overflow-y-hidden')
  }

  uncheckFilterCheckboxes() {
    // unchecked chart上面的兩顆checkbox
    this.averageCheckboxesTarget
      .querySelectorAll('input[type="checkbox"]')
      .forEach((checkbox) => {
        if (checkbox.checked) {
          checkbox.checked = false
        }
      })
  }

  handleClick(e) {
    const target = e.target;
    if (e.button !== 0 || target.classList.contains("SvgChartIndicatorControllerView")) {
      return
    }
    // テクニカル 和 ファンドや指数と比較 的 modal
    let indicators = document.querySelectorAll('.SvgChartIndicatorControllerView');
    
    if (!indicators.length) return

    let indicator_button = document.querySelectorAll('.SvgChartControllerIndicator');

    indicators.forEach((indicator, index) => {
      if (window.getComputedStyle(indicator).visibility === 'visible') {
        indicator_button[index]?.click();
      }
    });
  }
}
